import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Loader from "../../components/loader";
import Shell from "../../components/shell";
import { StudentsTable } from "../../components/tables/user-table";
import { Button } from "../../components/ui/button";
import { useGetAllStudents } from "../../hooks/useUser";
import { axiosInstance } from "../../lib/axios";

const UsersPage = () => {
  const [filters, setFilters] = useState({
    partnerId: "",
    membershipTypeId: "",
    dateFrom: "",
    dateTo: "",
    page: 1,
    limit: 20,
  });

  const toISOStartOfDay = (d) => {
    if (!d) return "";
    const [y, m, day] = d.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, day, 0, 0, 0, 0)).toISOString();
  };
  const toISOEndOfDay = (d) => {
    if (!d) return "";
    const [y, m, day] = d.split("-").map(Number);
    return new Date(Date.UTC(y, m - 1, day, 23, 59, 59, 999)).toISOString();
  };

  const startDateValue = filters.dateFrom ? filters.dateFrom.slice(0, 10) : "";
  const endDateValue = filters.dateTo ? filters.dateTo.slice(0, 10) : "";

  const onStartDateChange = (e) => {
    const v = e.target.value;
    setFilters((s) => ({
      ...s,
      dateFrom: v ? toISOStartOfDay(v) : "",
      page: 1,
    }));
  };
  const onEndDateChange = (e) => {
    const v = e.target.value;
    setFilters((s) => ({
      ...s,
      dateTo: v ? toISOEndOfDay(v) : "",
      page: 1,
    }));
  };

  const { data, isLoading } = useGetAllStudents(filters);

  const { data: partnersOptions } = useQuery({
    queryKey: ["partners-options"],
    queryFn: async () => {
      const res = await axiosInstance.get("/partners");
      return res.data?.data || [];
    },
  });

  const { data: membershipOptions } = useQuery({
    queryKey: ["membership-options"],
    queryFn: async () => {
      const res = await axiosInstance.get("/membership-types");
      return res.data?.data?.documents || [];
    },
  });

  return (
    <Shell pageHeader="All  Students" pageTitle="Users">
      <div className="mb-4 grid grid-cols-1 gap-3 md:grid-cols-6">
        <div className="col-span-2">
          <label className="block text-sm mb-1">Company</label>
          <select
            className="w-full border rounded p-2"
            value={filters.partnerId}
            onChange={(e) =>
              setFilters((s) => ({ ...s, partnerId: e.target.value, page: 1 }))
            }
          >
            <option value="">All</option>
            {(partnersOptions || []).map((p) => (
              <option key={p._id} value={p._id}>
                {p.partnerName}
              </option>
            ))}
          </select>
        </div>

        {/* Membership Levels */}
        <div className="col-span-2">
          <label className="block text-sm mb-1">Membership Levels</label>
          <select
            className="w-full border rounded p-2"
            value={filters.membershipTypeId}
            onChange={(e) =>
              setFilters((s) => ({
                ...s,
                membershipTypeId: e.target.value,
                page: 1,
              }))
            }
          >
            <option value="">All</option>
            {(membershipOptions || []).map((m) => (
              <option key={m._id} value={m._id}>
                {m.title}
              </option>
            ))}
          </select>
        </div>

        {/* Start Date */}
        <div className="col-span-1">
          <label className="block text-sm mb-1">Start date</label>
          <input
            type="date"
            className="w-full border rounded p-2"
            value={startDateValue}
            onChange={onStartDateChange}
          />
        </div>

        {/* End Date */}
        <div className="col-span-1">
          <label className="block text-sm mb-1">End date</label>
          <input
            type="date"
            className="w-full border rounded p-2"
            value={endDateValue}
            onChange={onEndDateChange}
          />
        </div>

        {/* Clear filters */}
        <div className="col-span-1 flex items-end">
          <Button
            variant="outline"
            onClick={() =>
              setFilters((s) => ({
                ...s,
                partnerId: "",
                membershipTypeId: "",
                dateFrom: "",
                dateTo: "",
                page: 1,
              }))
            }
          >
            Clear
          </Button>
        </div>
      </div>

      <div className="">
        {isLoading ? (
          <Loader />
        ) : (
          <StudentsTable data={data?.responseObject?.data?.documents} />
        )}
      </div>
    </Shell>
  );
};

export default UsersPage;
